import {Component, OnInit} from '@angular/core';
import {StorageService} from 'src/app/services/storage.service';
import {VerifyPhoneNumberComponent} from '../register/citizen/verify-phone-number/verify-phone-number.component';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {AddUserComponent} from 'src/app/modules/settings/system-settings-user-management/add-user/add-user.component';
import {SettingsService} from 'src/app/services/settings.service';
import {InstutionUser} from 'src/app/store/entities/instution-settings/instution-user/instution-user.model';
import {
  CitizenVerifyPhoneNumber
} from 'src/app/store/entities/citizens/register/citizen-verify-phone-number/citizen-verify-phone-number.model';
import {MediaImage, PictureTypeEnum} from 'src/app/store/entities/media-image/media-image.model';
import {citizenGetMediaImages} from 'src/app/store/entities/media-image/media-image.actions';
import {selectMediaImages} from 'src/app/store/entities/media-image/media-image.selectors';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Router} from "@angular/router";

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  fileUrl = environment.FILE_SERVER_URL;

  showHome: boolean = false;


  constructor(
    public route: Router
  )
  {
    this.route.events.subscribe((data: any) => {
      if (data?.url) {
        this.showHome = !(data?.url === '/')
      }
    })
  }

  ngOnInit(): void {

  }


}
